import { create } from "zustand";

export interface GalleryImage {
  id: string;
  url: string;
  alt?: string;
}

interface ImageGalleryState {
  isOpen: boolean;
  images: GalleryImage[] | null;
  initialImageIndex: number;
}

interface ImageGalleryActions {
  setGalleryImages: (params: {
    images: GalleryImage[];
    initialImageIndex?: number;
  }) => void;
  resetGallery: () => void;
}

const initState: ImageGalleryState = {
  isOpen: false,
  initialImageIndex: 0,
  images: [],
};

type ImageGalleryStore = ImageGalleryState & ImageGalleryActions;

export const useImageGalleryStore = create<ImageGalleryStore>((set) => ({
  ...initState,
  setGalleryImages: ({ images, initialImageIndex = 0 }) =>
    set(() => ({
      images,
      isOpen: images.length > 0,
      initialImageIndex:
        initialImageIndex >= 0 && initialImageIndex < images.length
          ? initialImageIndex
          : 0,
    })),
  resetGallery: () =>
    set(() => ({
      images: null,
      isOpen: false,
      initialImageIndex: 0,
    })),
}));
